// The light / dark / device switch in the top bar. Three icons rather than three words:
// it sits beside the bell and the name, and a row of labels there would outweigh both.
// Each carries its word as its accessible name and tooltip.
import he from '../i18n/he';
import { THEMES, useTheme } from '../context/ThemeContext';

const base = {
  viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.8,
  strokeLinecap: 'round', strokeLinejoin: 'round', 'aria-hidden': true,
};
const ICON = {
  system: ['M3 5h18v11H3z', 'M8 20h8', 'M12 16v4'],
  light: ['M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z', 'M12 2v2', 'M12 20v2', 'M4.9 4.9l1.4 1.4',
    'M17.7 17.7l1.4 1.4', 'M2 12h2', 'M20 12h2', 'M4.9 19.1l1.4-1.4', 'M17.7 6.3l1.4-1.4'],
  dark: ['M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5Z'],
};

export default function ThemeSwitch() {
  const ctx = useTheme();
  if (!ctx) return null;
  return (
    <span className="theme-switch" role="radiogroup" aria-label={he.theme.label}>
      {THEMES.map((t) => (
        <button key={t} type="button" role="radio" aria-checked={ctx.theme === t}
          aria-label={he.theme[t]} title={he.theme[t]}
          className={ctx.theme === t ? 'on' : ''} onClick={() => ctx.setTheme(t)}>
          <svg {...base}>{ICON[t].map((d) => <path key={d} d={d} />)}</svg>
        </button>
      ))}
    </span>
  );
}
